import { useAtomValue } from 'jotai'
import { ButtonDownloadCSV } from 'src/components/csv-button'
import { getParcelLink } from 'src/v2/utils/entity'
import { PARCEL_TYPES_BY_MCODE_MAP, PARCEL_TYPES_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { json2csv } from 'json-2-csv'
import { downloadContent } from 'src/utils/csv'

import * as sidebarAtoms from 'src/v2/state/owner-reveal/sidebar'
import * as atoms from 'src/v2/state/owner-reveal/entity-parcels'

export const OwnerParcelsCSVDownload = () => {
  const selectedEntity = useAtomValue(sidebarAtoms.selectedEntity)
  const parcels = useAtomValue(atoms.selectedEntityParcelsOverview)

  const onDowloadCSV = async () => {
    if (!parcels || !selectedEntity) {
      return
    }

    const parcelColumns = [
      'Link',
      'Parcel',
      'Associated Owners',
      'Type',
      'Lot Size (sqft)',
      'Lot Size (acres)',
      'Year Built',
      '# of Buildings',
      'APN',
    ]

    const rows = parcels.flatMap((parcel) => {
      return {
        Link: getParcelLink(parcel.id, true),
        Parcel: parcel.address ?? '-- ',
        'Associated Owners': parcel.owners?.length ?? '--',
        Type: PARCEL_TYPES_MAP.get(PARCEL_TYPES_BY_MCODE_MAP[parcel.mCode])?.label ?? '--',
        'Lot Size (sqft)': parcel.lotSizeSqft ?? '--',
        'Lot Size (acres)': parcel.lotSizeAcre ?? '--',
        'Year Built': parcel.yearBuilt ?? '--',
        '# of Buildings': parcel.numberOfBuildings ?? '--',
        APN: parcel.apn ?? '--',
      }
    })

    const ownerParcelsCSV = json2csv(rows, { keys: parcelColumns })
    const fileName = `${selectedEntity.name} Parcels`
    downloadContent(ownerParcelsCSV, `${fileName}.csv`)
  }
  return <ButtonDownloadCSV onDownload={onDowloadCSV} showText />
}
